module.exports = __webpack_public_path__ + "assets/icon-pref-deselected.4abe26c6.svg";